import { CSSProperties } from 'react'

import { IBaseReward, RewardStatusE } from 'primsell-shared-layer/types'

import * as S from './reward-status-indicator.styles'

export interface IRewardStatusIndicatorProps {
  status: IBaseReward['status']
}

const BADGE_BACKGROUND_COLOR: Record<RewardStatusE, CSSProperties['backgroundColor']> = {
  [RewardStatusE.COMPLETED]: '#D3D2FF',
  [RewardStatusE.PENDING]: '#CAFFE2',
  [RewardStatusE.ACTIVE]: '#B6D3FF',
  [RewardStatusE.DRAFT]: '#FFFFFF',
}

const BADGE_TEXT_COLOR: Record<RewardStatusE, CSSProperties['color']> = {
  [RewardStatusE.COMPLETED]: '#410A88',
  [RewardStatusE.PENDING]: '#012E10',
  [RewardStatusE.ACTIVE]: '#003380',
  [RewardStatusE.DRAFT]: '#383838',
}

const BADGE_TEXT: Record<RewardStatusE, CSSProperties['color']> = {
  [RewardStatusE.COMPLETED]: 'Expired',
  [RewardStatusE.PENDING]: 'New',
  [RewardStatusE.ACTIVE]: 'In Progress',
  [RewardStatusE.DRAFT]: 'Draft',
}

export const RewardStatusIndicator = ({ status = RewardStatusE.DRAFT }: IRewardStatusIndicatorProps) => {
  if (!status) {
    return null
  }
  return (
    <S.RewardStatusContainer backgroundColor={BADGE_BACKGROUND_COLOR[status]}>
      <S.StatusText textcolor={BADGE_TEXT_COLOR[status]}>{BADGE_TEXT[status]}</S.StatusText>
    </S.RewardStatusContainer>
  )
}
